/**
 * Page1 Component
 *
 * This component returns a page that contains a detailed description of the first item in the project list.
 */

import React from "react";

const Page1 = () => {
  return (
    <div className="page-content">
      <h2>Title 1</h2>
      <p>Additional content for the first item.</p>
    </div>
  );
};

export default Page1;
